/* eslint-disable no-sparse-arrays */
import { useMediaQuery } from 'react-responsive'
import { TrangChuLayout } from '../Layout/TrangChuLayout'
import { TrangChuLayoutMobile } from '../LayoutMobile/TrangChuLayoutMobile'
import Casino from '../Layout/DefaultLayout/Game/Casino/Casino'
import TheThao from '../Layout/DefaultLayout/Game/Thethao/TheThao'
import Fishing from '../Layout/DefaultLayout/Game/BanCa/Banca'
import DaGa from '../Layout/DefaultLayout/Game/DaGa/DaGa'
import { CaiDatMobile } from '../LayoutMobile/CaiDatMobile'
import { RutTienMobile } from '../LayoutMobile/CaiDatMobile/RutTienMobile'
import { NapTienMobile } from '../LayoutMobile/CaiDatMobile/NapTienMobile'
import { CaiDatRutTien } from '../LayoutMobile/CaiDatMobile/CaiDatRutTien'
import { ThemTkRutTien } from '../LayoutMobile/CaiDatMobile/CaiDatRutTien/ThemTkRutTien'
import { LichSuCuocMobile } from '../LayoutMobile/CaiDatMobile/LichSuCuoc'
import { LichSuNapRutMobile } from '../LayoutMobile/CaiDatMobile/LichSuNapRut'
import { ThayDoiMatKhauMobile } from '../LayoutMobile/CaiDatMobile/ThayDoiMatKhau'
import { HoaHongLayout } from '../Layout/DefaultLayout/Account/HoaHong'
import { KhuyenMaiMobile } from '../LayoutMobile/CaiDatMobile/KhuyenMaiMobile'
import { LienHeHoTroMobile } from '../LayoutMobile/CaiDatMobile/LienHeHoTro'
import Account from '../Layout/DefaultLayout/Account/Account'
import NoHu from '../Layout/DefaultLayout/Game/NoHu/NoHu'
import { XoSo } from '../Layout/DefaultLayout/Game/XoSo'
import KhuyenMai from '../Layout/DefaultLayout/Game/KhuyenMai/KhuyenMai'
import CSKH from '../Layout/DefaultLayout/Game/CSKH/CSKH'
import DanhSachGame from '../component/DanhSachGame/DanhSachGame'

const IsMobile = () => {
  return useMediaQuery({ query: '(max-width: 767px)' })
}

const publicRoutes = [
  {
    path: '/',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <TrangChuLayoutMobile /> : <TrangChuLayout />
    }
  },
  {
    path: '/casino',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <Casino /> : <Casino />
    }
  },
  {
    path: '/nohu',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <NoHu /> : <NoHu />
    }
  },
  {
    path: '/thethao',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <TheThao /> : <TheThao />
    }
  },
  {
    path: '/xoso',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <XoSo /> : <XoSo />
    }
  },
  {
    path: '/banca',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <Fishing /> : <Fishing />
    }
  },
  {
    path: '/daga',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <DaGa /> : <DaGa />
    }
  }
  ,
  {
    path: '/khuyenmai',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <KhuyenMai /> : <KhuyenMai />
    }
  },
  {
    path: '/cskh',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <CSKH /> : <CSKH />
    }
  },
  {
    path: '/accounttk',
    component: () => {
      const isMobile = IsMobile()
      return isMobile ? <Account /> : <Account />
    }
  },
  
  {
    path: '/usermobile',
    component: CaiDatMobile,
    layout: null
  },
  {
    path: '/ruttienmobile',
    component: CaiDatRutTien,
    layout: null
  },
  {
    path: '/naptienmobile',
    component: NapTienMobile,
    layout: null
  },

  {
    path: '/addtkrutmobile',
    component: ThemTkRutTien,
    layout: null
  },
  {
    path: '/lichsucuocmobile',
    component: LichSuCuocMobile,
    layout: null
  },
  {
    path: '/lichsunaprutmobile',
    component: LichSuNapRutMobile,
    layout: null
  },
  {
    path: '/repassmobile',
    component: ThayDoiMatKhauMobile,
    layout: null
  },
  {
    path: '/hoahong',
    component: HoaHongLayout,
    layout: null
  },
  {
    path: '/khuyenmaimobile',
    component: KhuyenMaiMobile,
    layout: null
  }
  ,
  {
    path: '/lienhehotro',
    component: LienHeHoTroMobile,
    layout: null
  }
  ,
  {
    path: '/game_list_mobile',
    component: DanhSachGame
  }
]
const privateRoutes = []
export { publicRoutes, privateRoutes }
